import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { REPORTS_FILTER_DATE_TIME_DATE_RANGE, REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE } from "../../../constants/element-type";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { requiredValidation, validateRequiredEndDate } from "../../../utilities/Validation";
import DateField from "../../date-field/date-field";
import Label from "../../label/label";

interface DetailsStepProps {
    onNext: (event: any) => void;
    onBack: (event: any) => void;
}

export const Detail: FC<DetailsStepProps> = ({ onBack, onNext }) => {
    const { translate } = useLocale();
    const { values, isValid, errors } = useFormikContext<any>();

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <div className="flex flex-col py-4 px-8">
            {
                values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE || values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_DATE_RANGE ?
                    <>
                        <span className={`mb-3 text-portal-blue-primary text-xl font-semibold`}>
                            {translate.byKey(TranslationKeys.selectDateFilter)}
                        </span>
                        <div className="mb-2">
                            <div className="flex flex-row justify-between" id='startDateLabelId' >
                                <Label
                                    htmlFor="startDate"
                                    className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.startDate)}:</Label>
                                {<span className='text-red-600 text-xs'>{errors.startDate}</span>}
                            </div>
                            <div className="flex flex-row justify-between" id='startDatePickerId' >
                                <Field
                                    valueName="startDate"
                                    type="text"
                                    name="startDate"
                                    component={DateField}
                                    validate={(value) => requiredValidation(value, translate)} />
                            </div>
                        </div>
                    </> : null}
            {
                values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_DATE_RANGE ?
                    <div className="mb-2">
                        <div className="flex flex-row justify-between" id='endDateLabelId' >
                            <Label
                                htmlFor="endDate"
                                className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.endDate)}:</Label>
                            {<span className='text-red-600 text-xs'>{errors.endDate}</span>}
                        </div>
                        <div className="flex flex-row justify-between" id='endDatePickerId' >
                            <Field valueName="endDate"
                                type="text"
                                name="endDate"
                                component={DateField}
                                validate={(value) => validateRequiredEndDate(value, values.startDate, translate)} />
                        </div>
                    </div> : null
            }
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5`}
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary  ${isValid ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type='button'
                    onClick={(e) => isValid ? onNext(e) : null}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}


